import type { LucideIcon } from "lucide-react";
import {
  Briefcase,
  Building2,
  CalendarClock,
  CircleUser,
  Shield,
  UsersRound,
  UserX,
} from "lucide-react";

/** Distinct Lucide icon per board role / grant label. */
export const ROLE_ICONS: Record<string, LucideIcon> = {
  Administrator: Shield,
  Executive: Briefcase,
  Office: Building2,
  Scheduler: CalendarClock,
  Workforce: UsersRound,
  Deactivated: UserX,
  Other: CircleUser,
};

export function getRoleIcon(role: string): LucideIcon {
  return ROLE_ICONS[role] ?? CircleUser;
}
